import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useToastStore } from '../lib/toast';
import { BRAND } from '../theme';

const BG: Record<string, string> = {
	'': BRAND.navy,
	success: '#16a34a',
	error: '#dc2626',
};

export function ToastHost() {
	const toasts = useToastStore((s) => s.toasts);
	return (
		<Box sx={{ position: 'fixed', bottom: 20, right: 20, zIndex: 9999, display: 'flex', flexDirection: 'column', gap: 1 }}>
			{toasts.map((t) => (
				<Paper
					key={t.id}
					elevation={6}
					sx={{
						bgcolor: BG[t.type] ?? BRAND.navy,
						color: '#fff',
						px: 2,
						py: 1.25,
						borderRadius: 2,
						fontSize: 13,
						fontWeight: 500,
						maxWidth: 280,
					}}
				>
					{t.msg}
				</Paper>
			))}
		</Box>
	);
}
